import {
  MyAreaDrawersState,
  SelectedMyAreaExcursionCard,
  ShopExcursionDiscounDetailsI,
} from '@msc-b2c/interfaces/interfaces';
import { OBSObjI } from '@msc-b2c/interfaces/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: MyAreaDrawersState = {
  standardExcursionDrawer: undefined,
  selectedMyAreaExcursionCard: null,
  selectedMyAreaOBSCard: null,
  isLayerMyAreaExcursionOpen: false,
  drawerPrice: null,
  relatedObsTitlesMap: {},
};

const myAreaDrawersSlice = createSlice({
  name: 'myAreaDrawers',
  initialState,
  reducers: {
    selectedMyAreaExcursionCard: (state, action: PayloadAction<SelectedMyAreaExcursionCard>) => {
      state.selectedMyAreaExcursionCard = action.payload;
    },
    selectedMyAreaOBSCard: (state, action: PayloadAction<OBSObjI | null>) => {
      state.selectedMyAreaOBSCard = action.payload;
    },
    isLayerMyAreaExcursionOpen: (state, action: PayloadAction<boolean>) => {
      state.isLayerMyAreaExcursionOpen = action.payload;
    },
    drawerPrice: (state, action: PayloadAction<ShopExcursionDiscounDetailsI | null>) => {
      state.drawerPrice = action.payload;
    },
    setRelatedObsTitlesMap: (state, action: PayloadAction<Record<string, string[]>>) => {
      state.relatedObsTitlesMap = action.payload;
    },
  },
});

export const {
  selectedMyAreaExcursionCard,
  isLayerMyAreaExcursionOpen,
  selectedMyAreaOBSCard,
  drawerPrice,
  setRelatedObsTitlesMap,
} = myAreaDrawersSlice.actions;
export default myAreaDrawersSlice.reducer;
